import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/_layout/mcp-clients/_layout/')({
  component: () => null, // La lista la rende il layout.
});
